/**
 * BondAuthorizedContact — ADR-034 + ADR-129 (autorização LGPD).
 *
 * "Quem o titular autorizou a falar em seu nome no Bond" — apenas
 * Persons (terceiros autorizados pelo titular). Distinto de
 * BondParticipant (papel operacional) e BondRelatedPerson (factual).
 *
 * Custódia de revogação: titular (via Brief 5 Central de Direitos) OU
 * DPO (em violação detectada). NÃO admin/owner do tenant.
 *
 * Audit dedicado: bond.authorized.granted / revoked / scope-changed.
 */
export const BOND_AUTHORIZED_CONTACT_STATUSES = ['active', 'revoked', 'expired'];
/**
 * Catálogo inicial de escopos LGPD. Cada bond.type tem subset aplicável
 * gerenciado via Capability Registry class='bond-authorization-scopes'.
 *
 * Lista abaixo é union de scopes recorrentes nos verticais do roadmap.
 * Tenant ativa apenas scopes relevantes.
 */
export const BOND_AUTHORIZATION_SCOPES = [
    // Comum (NetComet contract + customer-account)
    'financial',
    'technical-support',
    'contract-changes',
    'general-inquiry',
    'cancellation',
    // Item 363 F2 — concessão explícita do titular para alterações cadastrais
    // (S2 da spec confirmação-titular: pedido de quem tem o escopo é LEGÍTIMO;
    // a confirmação com o titular vira cortesia opcional, não recomendação).
    'cadastral-update',
    // Saúde (patient-care, home-care)
    'medical-decisions',
    'surgical-consent',
    'medication-decisions',
    'records-access',
    // Agenda (Frente B Bloco III PR2 — confirmação de visita/consulta por terceiro
    // autorizado): o titular concede a um familiar o direito de confirmar agendamentos
    // por ele. Gateia a ação `appointment_confirm` (intent-actions). Aplicável a
    // verticais de agenda nativa (saúde/serviços sem-ERP) e a contratos com confirmação.
    'appointment-confirmation',
    // Educação (student)
    'academic-decisions',
    'pickup-authorization',
    'medical-school',
    // Jurídico (legal-case, mediation)
    'court-filing',
    'negotiation',
    'document-receipt',
    'plea-bargain',
    // Comercial (opportunity, transaction-attempt, procurement)
    'signing',
    'price-negotiation',
    'procurement-decisions',
];
//# sourceMappingURL=authorized-contacts.js.map